module.exports = __webpack_public_path__ + "static/media/users.7da1e13e.svg";